export const articleIds = {
	batterySamplePage: '3cLHtAFCYPgONfrFqUNATB',
	samsungSettingsBatteryStatusCheck: '7bzOznOUyxSb7EWetOxFFX',
	samsungMembersAppBatteryStatusCheck: 'jQYvG30ZoMcKQlmF9ogQx',
};
